import * as MutationsType from "./mutationsType";

export default {
  [MutationsType.SET_INCOME_360PAY](state, payload) {
    state.income360pay = payload;
  },
};
